import React from 'react';
import { Box, Button } from '@razorpay/blade/components';
import NoResultsView from 'components/Fnf/ReleaseNetpay/NoResultsVIew';

export const ReportErrorState = ({
  onRetry,
  isRetrying,
  centered,
}: {
  onRetry: () => void;
  isRetrying?: boolean;
  centered?: boolean;
}) => {
  const view = (
    <NoResultsView
      title="Uh Oh, some error occurred :("
      description="Could not generate the report, Please try again. If issue persists, please contact support"
      actions={
        <Button onClick={onRetry} isLoading={isRetrying}>
          Retry
        </Button>
      }
    />
  );

  return centered ? (
    <Box display="grid" placeItems="center" height="100%">
      {view}
    </Box>
  ) : (
    <Box paddingY="spacing.10">{view}</Box>
  );
};
